import { render, staticRenderFns } from "./SecondPage.vue?vue&type=template&id=36c7dedd"
import script from "./SecondPage.vue?vue&type=script&lang=js"
export * from "./SecondPage.vue?vue&type=script&lang=js"
import style0 from "./SecondPage.vue?vue&type=style&index=0&id=36c7dedd&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c7dedd')) {
      api.createRecord('36c7dedd', component.options)
    } else {
      api.reload('36c7dedd', component.options)
    }
    module.hot.accept("./SecondPage.vue?vue&type=template&id=36c7dedd", function () {
      api.rerender('36c7dedd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/pricingChange/SecondPage.vue"
export default component.exports